module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Regular.b1f1c641.woff";